import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import { Button, Stack, styled } from '@mui/material'
import { MapComponent } from '../screens/localities/components/map/MapComponent'
import { IMooringType, IPosition } from '../generated-types'
import { CancelButton } from './CancelButton'
import { ShowDialogProps } from 'src/show-dialog'
import { GenericDialogLayout } from './GenericDialogLayout'

export const MapOuterStack = styled(Stack)(() => ({
  height: '70vh',
  width: '100%',
}))
interface OlexUploadConfirmDialogProps extends ShowDialogProps {
  updatedPositions: IPosition[]
  mooringType: IMooringType
  handleConfirm: (updatedPositions: IPosition[], pop, uploaderPop?: (...args: any[]) => any) => void
  setFileName?: React.Dispatch<React.SetStateAction<null>> | undefined
  setUpdatedPositions: React.Dispatch<React.SetStateAction<IPosition[]>>
  uploaderPop?: (...args: any[]) => any
}

export const OlexUploadConfirmDialog: React.FC<OlexUploadConfirmDialogProps> = ({
  updatedPositions,
  mooringType,
  handleConfirm,
  setFileName,
  setUpdatedPositions,
  uploaderPop,
  pop,
}) => {
  const { t } = useTranslation(['work-assignment', 'common'])
  const [isDisabled, setIsDisabled] = useState(false)
  return (
    <GenericDialogLayout
      title={t('verify-positions')}
      removedCloseButton
      pop={pop}
      actions={[
        <Stack
          className="flex justify-end gap-4 pt-4"
          key={'map-confirm-positions'}
          direction="row"
          justifyContent="center"
          alignItems="center"
          width="100%"
        >
          <CancelButton
            onClick={() => {
              pop(true)
              setFileName && setFileName(null)
              setUpdatedPositions([])
            }}
          >
            {t('cancel', { ns: 'common' })}
          </CancelButton>
          <Button
            variant="contained"
            disabled={isDisabled}
            onClick={() => {
              setIsDisabled(true)
              handleConfirm(updatedPositions, pop, uploaderPop)
            }}
          >
            {t('verify-positions')}
          </Button>
        </Stack>,
      ]}
    >
      <MapOuterStack direction="column" justifyContent="space-between" alignItems="center" spacing={2}>
        {
          <MapComponent
            positions={updatedPositions as IPosition[]}
            key={'olex-map-updated-confirm-positions'}
            mooringType={mooringType}
            layerControl={false}
            zoomControl={false}
            attributionControl={false}
            isModalView={true}
            gestureHandling={false}
          />
        }
      </MapOuterStack>
    </GenericDialogLayout>
  )
}
